import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { PriceTable } from './components/PriceTable';
import { ScrapInfo } from './components/ScrapInfo';
import { Products } from './components/Products';
import { About } from './components/About';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import './styles/globals.css';

export default function App() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <PriceTable />
        <ScrapInfo />
        <Products />
        <About />
        <Contact />
      </main>
      <Footer />
    </>
  );
}
